angular.module('impactx.product').controller('ProductEditReadonlyCtrl', [
    '$scope',
    '$routeParams',
    'dataGen',
    '$mdToast',
    'BackService',
    '$mdDialog',
    'CommentOnSaveService',
    'ToastService',
    '$config',
    'ConfirmationService',
    'TranslationService',
    'ToolbarService',
    ProductEditReadonlyCtrl
]);

function ProductEditReadonlyCtrl($scope, $routeParams, dataGen, $mdToast, BackService, $mdDialog, CommentOnSaveService, ToastService, $config, ConfirmationService,
                         TranslationService, ToolbarService) {
    var ctrl = this;
    dataGen.getData($scope, {
        id: $routeParams.id,
        catId: $routeParams.catId
    }, "/product/checkin/get").then(function () {
        defineButtons();
    });

    this.canAddPriceRule = function (priceGroup) {
        return false;
    }

    this.showMainDataDialog = function (event) {
        $mdDialog.show({
            controller: "AdditionalMainProductDataCtrl",
            controllerAs: "additionalMainProductDataCtrl",
            templateUrl: "modules/product/templates/mainproductdata.additional.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                data: $scope.data,
                headerLabel: $scope.trns.additionalMainData,
                confirmLabel: $scope.trns.confirm,
                abortLabel: $scope.trns.abort,
                noSelectedItemMessage: $scope.trns.noSelectedItemMessage,
                freeSelectionMessage: $scope.trns.freeSelectionMessageManufacturer,
                energieLabelHeaderLabel: $scope.trns.euEnergielabel,
                energieLabelMMD: $scope.trns.euEnergieLabelMMD,
                energieLabelDescriptionMMD: $scope.trns.euEnergieLabelDescriptionMMD
            }
        });
    };

    this.showAttributesDialog = function (event) {
        $mdDialog.show({
            controller: "ProductAttributesCtrl",
            controllerAs: "productAttributesCtrl",
            templateUrl: "modules/product/templates/product.attributes.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                data: $scope.data,
                headerLabel: $scope.trns.attributes,
                confirmLabel: $scope.trns.confirm,
                abortLabel: $scope.trns.abort,
                requiredLabel: $scope.trns.required,
                noSelectedItemMessage: $scope.trns.noSelectedItemMessage,
                trns: $scope.trns,
                freeSelectionMessage: $scope.trns.freeSelectionMessageAttribute
            }
        });
    };

    $scope.tinymceOptions = $config.tinymceOptions;

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.additionalMainData,
                action: ctrl.showMainDataDialog,
                type: 'dialogaction'
            },
            {
                label: $scope.trns.attributes,
                action: ctrl.showAttributesDialog,
                type: 'dialogaction'
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    ctrl.getPanelFallbackImage = function () {
        return $scope.data ? $scope.data.panelFallbackImage : undefined;
    }
}